export default "__VITE_ASSET__1jqb2Afp__"